import { ToggleButton } from 'vue-js-toggle-button';
import SectorService from '../../services/Sector.js';
import BenefitService from '../../services/Benefit.js';
import DevelopmentStageService from '../../services/DevelopmentStage.js';
import GeographicalAreaService from '../../services/GeographicalArea.js';
import CountryService from '../../services/Country.js';
import PatentStatusService from '../../services/PatentStatus.js';
import CompanyTypeService from '../../services/CompanyTypes.js';
import InvestmentTypeService from '../../services/InvestmentTypes.js';
import CurrencyService from '../../services/Currencies.js';
import Helper from '../../Helper.js';
import EditorJquery from './EditorJquery.js';
import RadialProgressBar from 'vue-radial-progress';

if($('#component-innovation-editor').length){
    var sprintf = require('sprintf-js').sprintf;
    var app = new Vue({
        el: '#component-innovation-editor',
        data: {
            innovation:{
                title:'',
                short_description:'',
                innovation_status_slug:'draft',
                primary_sector_id:'',
                geographical_area_id:'disabled',
                origin_country_id:'',
                patent_status_id:'disabled',
                development_stage_id:'disabled',
                image_location_file:'',
                image_location:'https://'+awsUrl+'/25/D3lcLGDuVhF7pvqqxvozuZSwvgMMoT4Pg5ErFSl3.jpg',
                header_banner_image_file:'',
                header_banner_image:'https://'+awsUrl+'/25/D3lcLGDuVhF7pvqqxvozuZSwvgMMoT4Pg5ErFSl3.jpg',
                owner_id:currentUserId,
                innovationId:innovationId,
                sectors:[],
                investments:[],
                benefits:[],
                currency_id:'disabled',
                company_type_id:'disabled',
                employees:'disabled',
                seek_opp:false,
                seek_funding:false,
                collaborators:[],
                invited: [],
                strapline: '',
                company_name: '',
                company_url: '',
                long_description: '',
                key_benefits: '',
                applications: '',
                video_embed_link: '',
                amount: 0,
                additional_info: '',
                opportunities: '',
                url: '',
                ai_integration: false,
                university_id: '',
                h_captcha_response: ''
            },
            university:university,
            loading: true,
            sidebar:true,
            cardDetails:true,
            additionalDetails:false,
            fundingAndOpportunities:false,
            media:false,
            collaborators:false,
            createdModal: true,
            justCreated: false,
            cardView: true,
            completedSteps: 0,
            totalSteps: 0,
            cardDetailsCompletedSteps: 0,
            cardDetailsTotalSteps: 0,
            additionalDetailsCompletedSteps: 0,
            additionalDetailsTotalSteps: 0,
            uploaderErrors:[],
            sectors:[],
            countries:[],
            developmentStages:[],
            benefits:[],
            patentStatuses:[],
            geographicalAreas:[],
            companyTypes:[],
            investmentTypes:[],
            currencies:[],
            employees:['1-10','11-50','51-500','501+'],
            radialColour:'#5B45E0',
            radialWidth:5,
            radialInnerColor:'#E0E0E0',
            loadingMessage:'Loading Innovation Editor',
            newUserEmail:'',
            currentUserId: currentUserId,
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            applicationId: applicationId,
            Helper: Helper,
            EditorJquery: EditorJquery,
            awsUrl: awsUrl,
            privateOrganisation: privateOrganisation,
            invited: false,
            showUploadMedia: false,
            dataImages: [],
            imageMedia: false,
            bannerMedia: false,
            targetId: '',
            step_1: false,
            step_2: false,
            step_3: false,
            owner_image: ownerImage,
            owner_name: ownerName,
            request: request,
            step: 1,
            tags: [],
            showCrumbs: true,
            file: '',
            from: from,
            ai_loading: false,
            currentIndex: 0,
            response: '',
            straplineCurrentIndex: 0,
            straplineResponse: '',
            keyBenefitsCurrentIndex: 0,
            keyBenefitsResponse: '',
            applicationsCurrentIndex: 0,
            applicationsResponse: '',
            isFile: false,
            field: [],
            scrapeDone: false,
            cancelRequest: null,
            straplineImg: '/images/magic-wand.png',
            straplineTitle: 'Generate AI Response',
            straplineTimeout: null,
            shortDescriptionImg: '/images/magic-wand.png',
            shortDescriptionTitle: 'Generate AI Response',
            shortDescriptionTimeout: null,
            primarySectorImg: '/images/magic-wand.png',
            primarySectorTitle: 'Generate AI Response',
            longDescriptionImg: '/images/magic-wand.png',
            longDescriptionTitle: 'Generate AI Response',
            longDescriptionTimeout: null,
            keyBenefitsImg: '/images/magic-wand.png',
            keyBenefitsTitle: 'Generate AI Response',
            keyBenefitsTimeout: null,
            applicationsImg: '/images/magic-wand.png',
            applicationsTitle: 'Generate AI Response',
            applicationsTimeout: null,
            ai_loading_ready: false,
            prev_url: '',
            allow_innovation: allow_innovation,
            video_size: '',
            disablePrivateToggle: disablePrivateToggle
        },
        methods: {
            getInnovation(id){
                axios.get('/api/v1/innovation/'+id)
                .then((response) =>  {
                    this.innovation = response.data;
                    this.postLoad();
                })
                .catch((error) =>  {
                    this.errorHandler(error);
                })
            },
            setSelectParams() {
                if (!this.innovation.development_stage_id) {
                    this.innovation.development_stage_id = 'disabled';
                }
                if (!this.innovation.geographical_area_id) {
                    this.innovation.geographical_area_id = 'disabled';
                }
                if (!this.innovation.patent_status_id) {
                    this.innovation.patent_status_id = 'disabled';
                }
                if (!this.innovation.company_type_id) {
                    this.innovation.company_type_id = 'disabled';
                }
                if (!this.innovation.employees) {
                    this.innovation.employees = 'disabled';
                }
                if (!this.innovation.currency_id) {
                    this.innovation.currency_id = 'disabled';
                }
            },
            saveInnovation(status, applying = false, jquery_call = false){
                if (this.isFile === true && this.video_size > 10) {
                    this.$toasted.error("30 Second Intro Video too long for upload. The video must be below 10 MB.");
                    return
                } else if (status === 'publish' && !this.allow_innovation) {
                    if(this.requiredFields() != true || this.requiredFieldsOther() != true){
                        return;
                    }
                } else {
                    if (!this.innovation.title) {
                        this.$toasted.error('Title required');
                        return
                    }
                }

                if (this.innovation.development_stage_id == 'disabled') {
                    this.innovation.development_stage_id = '';
                }
                if (this.innovation.geographical_area_id == 'disabled') {
                    this.innovation.geographical_area_id = '';
                }
                if (this.innovation.patent_status_id == 'disabled') {
                    this.innovation.patent_status_id = '';
                }
                if (this.innovation.company_type_id == 'disabled') {
                    this.innovation.company_type_id = '';
                }
                if (this.innovation.employees == 'disabled') {
                    this.innovation.employees = '';
                }
                if (this.innovation.currency_id == 'disabled') {
                    this.innovation.currency_id = '';
                }

                // if ($('.tag-data').val() !== undefined && $('.tag-data').val() !== '') {
                //     this.tags = [];
                //     let tagsData = JSON.parse($('.tag-data').val());
                //     tagsData.forEach(element => this.tags.push(element.tag))
                // }

                var formData = new FormData();
                formData = this.appendFields(formData);
                formData.append('innovation_status_slug', status);
                if ((!this.innovation.id && !this.innovation.image_location_file) || this.imageMedia === true) {
                    formData.append('image_location', this.innovation.image_location.replace("//" + this.awsUrl + "/", ""));
                    this.imageMedia = false;
                } else if (this.innovation.image_location_file) {
                    formData.append('image_location', this.innovation.image_location_file);
                }
                if ((!this.innovation.id && !this.innovation.header_banner_image_file) || this.bannerMedia === true) {
                    formData.append('header_banner_image', this.innovation.header_banner_image.replace("//" + this.awsUrl + "/", ""));
                    this.bannerMedia = false;
                } else if (this.innovation.header_banner_image_file) {
                    formData.append('header_banner_image', this.innovation.header_banner_image_file);
                }

                if(this.innovation.id){

                    this.loading = true;
                    this.loadingMessage = 'Saving Innovation';

                    axios.post('/api/v1/innovation/'+this.innovation.id, formData)
                    .then((response) =>  {

                        this.removeInnovationSession()

                        if (status === 'publish' && !applying) {
                            location.replace("/under-review/innovation");
                            return;
                        }

                        if(this.applicationId && applying){
                            window.location.replace("/organisation/"+this.networkGroupSlug+"/"+this.networkSlug+"/apply/innovation/"+this.applicationId+"/review");
                            return;
                        }

                        if(applying){
                            window.location.replace("/organisation/"+this.networkGroupSlug+"/"+this.networkSlug+"/apply/innovation/vetting/"+response.data.id+"/create");
                            return;
                        }

                        this.innovation = response.data;
                        this.postLoad(jquery_call);
                        this.$toasted.success('Your Innovation has been Saved.');
                    })
                    .catch((error) =>  {
                        this.errorHandler(error);
                    });
                }else{
                    this.loading = true;
                    this.loadingMessage = 'Creating Innovation';

                    axios.post('/api/v1/innovation', formData)
                    .then((response) =>  {

                        this.removeInnovationSession()

                        if (status === 'publish' && !applying) {
                            location.replace("/under-review/innovation");
                            return;
                        }

                        if (this.networkSlug) {
                            if (applying) {
                                window.location.replace("/organisation/" + this.networkGroupSlug + "/" + this.networkSlug + "/apply/innovation/vetting/" + response.data.id + "/create");
                            } else {
                                window.location.replace("/organisation/" + this.networkGroupSlug + "/" + this.networkSlug + "/apply/apply-as/innovation/edit/" + response.data.id + "?justCreated=true&step=" + this.step);
                            }
                        } else {
                            window.location.replace("/innovation/edit/" + response.data.id + "?justCreated=true&step=" + this.step);
                        }
                    })
                    .catch((error) =>  {
                        this.errorHandler(error);
                    });
                }
            },
            removeInnovationSession() {
                sessionStorage.removeItem('innovation')
            },
            appendFields(formData) {
                formData.append('private', this.innovation.private ? 1 : 0);
                formData.append('total', this.totalSteps);
                formData.append('completed', this.completedSteps);

                if(this.totalSteps == this.completedSteps){
                    formData.append('completed_step', 4);
                }else{
                    formData.append('completed_step', 1);
                }
                formData.append('title', this.innovation.title && this.innovation.title != 'null' ? this.innovation.title : '');
                formData.append('seek_opp', this.innovation.seek_opp ? 1 : 0);
                formData.append('seek_funding', this.innovation.seek_funding ? 1 : 0);
                formData.append('sectors', this.innovation.sectors);
                formData.append('benefits', this.innovation.benefits);
                formData.append('investment_types', this.innovation.investments);
                formData.append('from_private_organisation', this.innovation.from_private_organisation);
                formData.append('short_description', this.innovation.short_description && this.innovation.short_description != 'null' ? this.innovation.short_description : '');
                formData.append('primary_sector_id', this.innovation.primary_sector_id);
                formData.append('geographical_area_id', this.innovation.geographical_area_id);
                formData.append('origin_country_id', this.innovation.origin_country_id);
                formData.append('patent_status_id', this.innovation.patent_status_id);
                formData.append('development_stage_id', this.innovation.development_stage_id);
                formData.append('currency_id', this.innovation.currency_id);
                formData.append('company_type_id', this.innovation.company_type_id);
                formData.append('employees', this.innovation.employees);
                formData.append('strapline', this.innovation.strapline && this.innovation.strapline != 'null' ? this.innovation.strapline : '');
                formData.append('company_name', this.innovation.company_name && this.innovation.company_name != 'null' ? this.innovation.company_name : '');
                formData.append('company_url', this.innovation.company_url && this.innovation.company_url != 'null' ? this.innovation.company_url : '');
                formData.append('long_description', this.innovation.long_description && this.innovation.long_description != 'null' ? this.innovation.long_description : '');
                formData.append('key_benefits', this.innovation.key_benefits && this.innovation.key_benefits != 'null' ? this.innovation.key_benefits : '');
                formData.append('applications', this.innovation.applications && this.innovation.applications != 'null' ? this.innovation.applications : '');
                formData.append('video_embed_link', this.innovation.video_embed_link && this.innovation.video_embed_link != 'null' ? this.innovation.video_embed_link : '');
                formData.append('amount', !this.innovation.amount || this.innovation.amount == 'null' ? 0 : this.innovation.amount);
                formData.append('additional_info', this.innovation.additional_info && this.innovation.additional_info != 'null' ? this.innovation.additional_info : '');
                formData.append('opportunities', this.innovation.opportunities && this.innovation.opportunities != 'null' ? this.innovation.opportunities : '');
                formData.append('tags', this.tags);
                formData.append('video', this.file);
                formData.append('url', this.innovation.url && this.innovation.url != 'null' ? this.innovation.url : '');
                formData.append('ai_integration', this.innovation.ai_integration ? 1 : 0);
                formData.append('university_id', this.innovation.university_id === true ? this.university.id : '');

                if(this.privateOrganisation == 1 && this.networkSlug){
                    formData.append('privateOrganisation', this.networkSlug);
                }

                let collaboratorIds = this.getCollaboratorIds();
                formData.append('collaboratorIds', collaboratorIds);
                formData.append('invited', this.innovation.invited);
                formData.append('h-captcha-response', this.innovation.h_captcha_response);

                return formData;
            },
            getCollaboratorIds(){
                return this.innovation.collaborators.map(user => user.id);
            },
            sectorChange(){
                var sectorID = this.innovation.primary_sector_id;
                var sector = this.sectors.filter(obj => {
                    return obj.id === sectorID;
                });
                if(!this.innovation.id && !this.innovation.header_banner_image_file){
                    this.innovation.header_banner_image = sector[0].image_location;
                }
                if(!this.innovation.id && !this.innovation.image_location_file){
                    let images = sector[0].sector_images;
                    this.innovation.image_location = images[Math.floor(Math.random() * images.length)].image_location;
                }
            },
            previewLogoImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.innovation.image_location = fileBlob;
                    this.innovation.image_location_file = file;
                    this.showUploadMedia = false;
                }
            },
            previewBannerImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.innovation.header_banner_image = fileBlob;
                    this.innovation.header_banner_image_file = file;
                    this.showUploadMedia = false;
                }
            },
            imageSize(url) {
                const img = document.createElement("img");

                const promise = new Promise((resolve, reject) => {
                    img.onload = () => {
                        // Natural size is the actual image size regardless of rendering.
                        // The 'normal' `width`/`height` are for the **rendered** size.
                        const width  = img.naturalWidth;
                        const height = img.naturalHeight;

                        // Resolve promise with the width and height
                        resolve({width, height});
                    };

                    // Reject promise on error
                    img.onerror = reject;
                });

                // Setting the source makes it start downloading and eventually call `onload`
                img.src = url;

                return promise;
            },
            getFileType(file, type, event){

                const filereader = new FileReader()
                const fileClone = file;
                const objectUrl = URL.createObjectURL(fileClone);

                filereader.onloadend = (evt) => {

                    if (evt.target.readyState === FileReader.DONE) {
                        const uint = new Uint8Array(evt.target.result)
                        let bytes = []
                        uint.forEach((byte) => {
                            bytes.push(byte.toString(16))
                        })
                        if (type == 'logo') {
                            this.innovation.image_location = URL.createObjectURL(fileClone);
                            this.innovation.image_location_file = fileClone;
                        } else if (type == 'preview') {
                            this.innovation.header_banner_image = URL.createObjectURL(fileClone);
                            this.innovation.header_banner_image_file = fileClone;
                        }
                    }
                }

                const blob = file.slice(0, 4);

                (async() => {
                    const imageDimensions = await this.imageSize(objectUrl);

                    if(imageDimensions.height < 2500 && imageDimensions.width < 2500) {
                        filereader.readAsArrayBuffer(blob);
                        this.showUploadMedia = false;
                    }else{
                        this.$toasted.error("Your images dimensions are too large. The image must be less than 2500px wide by 2500px high.");
                    }
                })();
            },
            getYouTubeId(url) {
                const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
                const match = url.match(regExp);

                return (match && match[2].length === 11)
                  ? match[2]
                  : null;
            },
            addhttp(url) {
                if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
                    url = "http://" + url;
                }
                return url;
            },
            postLoad(jquery_call = false) {
                this.setSelectParams()
                this.setVideo()
                this.$nextTick(function () {
                    this.loading = false;

                    if(jquery_call == false){
                        EditorJquery.jqueryHelpers(this);
                    }
                    if (this.innovation.url && this.innovation.title) {
                        this.scrapeDone = true;
                        if (this.step == 2) {
                            if (!this.innovation.company_name || this.innovation.company_name === 'null') {
                                this.getAi('innovation_organisation_name');
                            }
                            if (!this.innovation.company_type_id || this.innovation.company_type_id === 'disabled') {
                                this.getAi('innovation_organisation_type');
                            }
                        }
                    }
                    if (!this.innovation.company_url) {
                        this.innovation.company_url = this.innovation.url
                    }
                    this.cardDetails = false;
                    this.additionalDetails = true;
                });
            },
            stepsCalculation(){
                let innovation = this.innovation;
                this.cardDetailsCompletedSteps = 0;
                this.additionalDetailsCompletedSteps = 0;

                innovation.title ? this.cardDetailsCompletedSteps++ : null;
                innovation.short_description ? this.cardDetailsCompletedSteps++ : null;
                innovation.primary_sector_id ? this.cardDetailsCompletedSteps++ : null;
                innovation.origin_country_id ? this.cardDetailsCompletedSteps++ : null;
                innovation.strapline ? this.cardDetailsCompletedSteps++ : null;
                this.cardDetailsTotalSteps = 5;

                innovation.long_description ? this.additionalDetailsCompletedSteps++ : null;
                innovation.development_stage_id && innovation.development_stage_id != 'disabled' ? this.additionalDetailsCompletedSteps++ : null;
                innovation.key_benefits ? this.additionalDetailsCompletedSteps++ : null;
                innovation.applications ? this.additionalDetailsCompletedSteps++ : null;
                innovation.company_name ? this.additionalDetailsCompletedSteps++ : null;
                innovation.geographical_area_id && innovation.geographical_area_id != 'disabled' ? this.additionalDetailsCompletedSteps++ : null;
                innovation.employees && innovation.employees != 'disabled' ? this.additionalDetailsCompletedSteps++ : null;
                innovation.company_type_id && innovation.company_type_id != 'disabled' ? this.additionalDetailsCompletedSteps++ : null;
                this.additionalDetailsTotalSteps = 8;

                this.completedSteps = this.cardDetailsCompletedSteps + this.additionalDetailsCompletedSteps;
                this.totalSteps = this.cardDetailsTotalSteps + this.additionalDetailsTotalSteps;
            },
            addCollaborator(){
                if(!this.newUserEmail){
                    this.$toasted.error('Please add an email address');
                    return;
                }

                this.loading = true;
                this.loadingMessage = 'Looking for User';

                axios.post('/api/v1/find-user', {
                    'email':this.newUserEmail,
                    'type': 'innovation',
                    'type_id': this.innovation.id ? this.innovation.id : null
                })
                .then((response) =>  {
                    if (response.data === 'New user') {
                        if (!this.innovation.hasOwnProperty('invited')) {
                            this.innovation.invited = [];
                        }
                        this.innovation.invited.push(this.newUserEmail);
                        this.newUserEmail = '';
                        this.$toasted.success('Collaborator added, please save to apply changes');
                    } else {
                        let newUser = response.data;

                        let existingUser = this.innovation.collaborators.filter(user => {
                            return user.id === newUser.id;
                        });

                        this.newUserEmail = '';

                        if (!existingUser.length) {
                            this.innovation.collaborators.push(newUser);
                            this.$toasted.success('Collaborator added, please save to apply changes');
                        } else {
                            this.$toasted.error('This user is already a collaborator on your innovation');
                        }
                    }

                    this.$nextTick(function () {
                        this.loading = false;
                    });

                })
                .catch((error) =>  {
                    this.$toasted.error(error.response.data);
                    this.loading = false;
                });
            },
            removeUser(index){
                this.innovation.collaborators.splice(index, 1);
            },
            removeInvitedUser(index){
                this.innovation.invited.splice(index, 1);
            },
            removeFromPrivateOrganisation(){
                $('.tooltipped').tooltip('close');
                this.innovation.from_private_organisation = false;
                this.saveInnovation(this.innovation.innovation_status_slug);
            },
            errorHandler(error){
                if(typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    let errors = error.response.data.errors;
                    if (errors) {
                        for (let field of Object.keys(errors)) {
                            this.$toasted.error(errors[field][0]);
                        }
                    }
                }
                this.loading = false;
            },
            justCreatedCheck(){
                if(window.location.href.indexOf('justCreated') != -1){
                    this.justCreated = true;
                }else{
                    this.justCreated = false;
                }
            },
            uploadMedia(id) {
                this.getUploadedMedia();
                this.targetId = id;
                this.showUploadMedia = true;
            },
            getUploadedMedia() {
                axios.get('/api/v1/get-uploaded-media')
                    .then((response) => {
                        if (response && response.data && response.data.hasOwnProperty('uploads')) {
                            this.dataImages = response.data.uploads;
                        }
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
            },
            onSelectImage(data) {
                if (this.targetId === 'image') {
                    this.innovation.image_location = data.src;
                    this.imageMedia = true;
                } else if (this.targetId === 'banner') {
                    this.innovation.header_banner_image = data.src;
                    this.bannerMedia = true;
                }
                this.showUploadMedia = false;
            },
            selectMethod(result, files) {
                if (result == 'EXTENSION_ERROR') {
                    this.$toasted.error('The selected files contain invalid extensions.');
                    return;
                } else if (result == 'FILE_SIZE_ERROR') {
                    this.$toasted.error('The selected files size exceeded limit.');
                    return;
                }
                if (files && files[0]) {
                    let file = files[0], vm = this, img = new Image();
                    img.onload = function () {
                        if (this.width > 3000 || this.height > 3000) {
                            vm.$toasted.error('The selected image dimensions exceeded limit (3000*3000).');
                        } else {
                            if (vm.targetId === 'image') {
                                vm.previewLogoImage(img.src, file);
                            } else if (vm.targetId === 'banner') {
                                vm.previewBannerImage(img.src, file);
                            }
                        }
                    }
                    img.src = URL.createObjectURL(file);
                }
            },
            onTextChange() {
                const quill = this.$refs.editor.quill
                const len = quill.getLength()
                $(".short-desc-character-count").find(".count").text(181 - len);
                if (len > 180) {
                    quill.deleteText(180, len);
                }
            },
            requiredFields() {
                if (!this.innovation.title) {
                    this.$toasted.error('Title required');
                    return false;
                }
                if (!this.innovation.strapline) {
                    this.$toasted.error('Strapline required');
                    return false;
                }
                if (!this.innovation.short_description) {
                    this.$toasted.error('Short Description required');
                    return false;
                }
                if (!this.innovation.primary_sector_id) {
                    this.$toasted.error('Primary Market Sector required');
                    return false;
                }
                if (!this.innovation.origin_country_id) {
                    this.$toasted.error('Country of Origin required');
                    return false;
                }
                return true;
            },
            requiredFieldsOther() {
                if (this.innovation.development_stage_id === 'disabled') {
                    this.$toasted.error('Stage of Development required');
                    return false;
                }
                if (this.innovation.geographical_area_id === 'disabled') {
                    this.$toasted.error('Geographical Application required');
                    return false;
                }
                if (!this.innovation.company_name) {
                    this.$toasted.error('Organisation Name required');
                    return false;
                }
                if (this.innovation.company_type_id === 'disabled') {
                    this.$toasted.error('Organisation Type required');
                    return false;
                }
                if (this.innovation.employees === 'disabled') {
                    this.$toasted.error('Number of Employees required');
                    return false;
                }
                if (!this.innovation.long_description) {
                    this.$toasted.error('About required');
                    return false;
                }
                if (!this.innovation.key_benefits) {
                    this.$toasted.error('Key Benefits required');
                    return false;
                }
                if (!this.innovation.applications) {
                    this.$toasted.error('Applications required');
                    return false;
                }
                return true;
            },
            nextStep() {
                if (!this.allow_innovation) {
                    if(this.requiredFields() != true){
                        return;
                    }
                } else {
                    if (!this.innovation.title) {
                        this.$toasted.error('Title required');
                        return
                    }
                }

                if (this.allow_innovation || (this.innovation.title && this.innovation.strapline && this.innovation.short_description &&
                    this.innovation.primary_sector_id && this.innovation.origin_country_id)) {
                    if (this.innovation.title) {
                        this.innovation.h_captcha_response = document.querySelector('textarea[name="h-captcha-response"]').value
                        this.reload(2);
                    }
                }
            },
            nextStep2() {
                if (!this.allow_innovation) {
                    if(this.requiredFields() != true || this.requiredFieldsOther() != true){
                        return;
                    }
                } else {
                    if (!this.innovation.title) {
                        this.$toasted.error('Title required');
                        return
                    }
                }

                if (this.isFile === true && this.video_size > 10) {
                    this.$toasted.error("30 Second Intro Video too long for upload. The video must be below 10 MB.");
                } else if (this.imageMedia === true || this.innovation.image_location_file || this.bannerMedia === true || this.innovation.header_banner_image_file || this.isFile === true) {
                    this.isFile = false;
                    this.$toasted.error("You need to hit 'Save draft' button otherwise your media changes will not be reflected.");
                } else if (this.allow_innovation || (this.innovation.title && this.innovation.strapline && this.innovation.short_description &&
                    this.innovation.primary_sector_id && this.innovation.origin_country_id &&
                    this.innovation.development_stage_id !== 'disabled' && this.innovation.company_name &&
                    this.innovation.long_description && this.innovation.key_benefits && this.innovation.applications &&
                    this.innovation.geographical_area_id !== 'disabled' && this.innovation.employees !== 'disabled' &&
                    this.innovation.company_type_id !== 'disabled')) {
                    if (this.innovation.title) {
                        this.reload(3);
                    }
                }
            },
            getRef(id) {
                if (id) {
                    return sprintf('%05d', id);
                }
            },
            setInnovation() {
                this.innovation = this.request;
                EditorJquery.jqueryHelpers(this);
                this.loading = false;
                if (this.innovation.url && this.innovation.title) {
                    this.scrapeDone = true;
                    if (this.step == 2) {
                        if (!this.innovation.company_name || this.innovation.company_name === 'null') {
                            this.getAi('innovation_organisation_name');
                        }
                        if (!this.innovation.company_type_id || this.innovation.company_type_id === 'disabled') {
                            this.getAi('innovation_organisation_type');
                        }
                    }
                }
                if (!this.innovation.company_url) {
                    this.innovation.company_url = this.innovation.url
                }
                this.postLoad();
            },
            setVideo() {
                if (this.innovation.id) {
                    axios.get('/api/v1/innovation/video/' + this.innovation.id)
                        .then((response) => {
                            this.file = response.data
                        })
                        .catch((error) => {
                            this.errorHandler(error);
                        })
                }
            },
            showMedia() {
                this.$modal.show('media-modal');
            },
            showCard() {
                this.$modal.show('card-modal');
            },
            showHighlights() {
                this.$modal.show('highlights-modal');
            },
            showOrganisation() {
                this.$modal.show('organisation-modal');
            },
            showSummary() {
                this.$modal.show('summary-modal');
            },
            showFunding() {
                this.$modal.show('funding-modal');
            },
            createStep(step) {
                axios.post('/innovation/create/steps', {
                    'innovation': this.innovation,
                    'step': step
                })
                    .then((response) => {
                        this.reload(step);
                    })
                    .catch((error) => {
                        this.$toasted.error(error.response.data);
                    });
            },
            previewVideo(){
                let video = document.getElementById('video-preview');
                let reader = new FileReader();
                reader.readAsDataURL(this.file);
                reader.addEventListener('load', function () {
                    video.src = reader.result;
                });
                this.isFile = true;
            },
            handleFileUpload( event ){
                this.isFile = false;
                this.file = event.target.files[0];
                this.video_size = this.file['size'] / 1000000
                this.previewVideo();
            },
            reload(step = 1) {
                if (location.href.includes("/innovation/edit") || location.href.includes("/innovation/create")) {
                    let url = new URL(location.href);
                    url.searchParams.set('step', step);
                    location.replace(url);
                } else {
                    location.replace('/innovation/create?step=' + step);
                }
            },
            getAi(name) {
                if (this.innovation.url && this.innovation.title) {
                    if (name === 'innovation_short_description' || name === 'innovation_long_description') {
                        this.currentIndex = 0;
                        this.response = '';
                    }
                    if (name === 'innovation_short_description') {
                        this.innovation.short_description = '';
                    }
                    if (name === 'innovation_long_description') {
                        this.innovation.long_description = '';
                    }
                    if (name === 'innovation_strapline') {
                        this.innovation.strapline = '';
                        this.straplineCurrentIndex = 0;
                        this.straplineResponse = '';
                    }
                    if (name === 'innovation_organisation_name') {
                        this.innovation.company_name = ''
                    }
                    if (name === 'innovation_key_benefits') {
                        this.innovation.key_benefits = '';
                        this.keyBenefitsCurrentIndex = 0;
                        this.keyBenefitsResponse = '';
                    }
                    if (name === 'innovation_applications') {
                        this.innovation.applications = '';
                        this.applicationsCurrentIndex = 0;
                        this.applicationsResponse = '';
                    }
                    let prompts = [];
                    prompts.push(this.innovation.title);

                    let axiosSource = axios.CancelToken.source();
                    this.cancelRequest = { cancel: axiosSource.cancel };

                    let timeoutId = setTimeout(() => {
                        this.cancelRequest.cancel()
                        this.field[name] = true
                        this.wand(name)
                    }, 29000);

                    axios.post('/api/v1/innovations/ai', {
                        'name': name,
                        'prompts': prompts,
                        'url': this.innovation.url
                    }, {
                        cancelToken: axiosSource.token
                    })
                        .then((response) => {
                            clearTimeout(timeoutId);
                            if (name === 'innovation_strapline') {
                                this.straplineImg = '/images/stop-button.png';
                                this.straplineTitle = 'Stop Generating Response';
                            } else if (name === 'innovation_short_description') {
                                this.shortDescriptionImg = '/images/stop-button.png';
                                this.shortDescriptionTitle = 'Stop Generating Response';
                            } else if (name === 'innovation_long_description') {
                                this.longDescriptionImg = '/images/stop-button.png';
                                this.longDescriptionTitle = 'Stop Generating Response';
                            } else if (name === 'innovation_key_benefits') {
                                this.keyBenefitsImg = '/images/stop-button.png';
                                this.keyBenefitsTitle = 'Stop Generating Response';
                            } else if (name === 'innovation_applications') {
                                this.applicationsImg = '/images/stop-button.png';
                                this.applicationsTitle = 'Stop Generating Response';
                            }
                            if (response.data) {
                                if (name === 'innovation_primary_sector') {
                                    this.primarySectorImg = '/images/magic-wand.png';
                                    this.primarySectorTitle = 'Generate AI Response';
                                    this.field['innovation_primary_sector'] = 'undefined';
                                    let sector = this.sectors.filter(obj => {
                                        return obj.name === response.data;
                                    });
                                    this.innovation.primary_sector_id = sector[0].id
                                } else if (name === 'innovation_organisation_type') {
                                    let type = this.companyTypes.filter(obj => {
                                        return obj.name === response.data;
                                    });
                                    this.innovation.company_type_id = type[0].id
                                }
                                if (name === 'innovation_strapline') {
                                    this.innovation.strapline = response.data
                                    this.straplineImg = '/images/magic-wand.png';
                                    this.straplineTitle = 'Generate AI Response';
                                    this.field['innovation_strapline'] = 'undefined';
                                } else if (name === 'innovation_short_description') {
                                    this.innovation.short_description = response.data
                                    this.shortDescriptionImg = '/images/magic-wand.png';
                                    this.shortDescriptionTitle = 'Generate AI Response';
                                    this.field['innovation_short_description'] = 'undefined';
                                } else if (name === 'innovation_long_description') {
                                    this.innovation.long_description = response.data
                                    this.longDescriptionImg = '/images/magic-wand.png';
                                    this.longDescriptionTitle = 'Generate AI Response';
                                    this.field['innovation_long_description'] = 'undefined';
                                } else if (name === 'innovation_organisation_name') {
                                    this.innovation.company_name = response.data
                                } else if (name === 'innovation_key_benefits') {
                                    this.innovation.key_benefits = response.data
                                    this.keyBenefitsImg = '/images/magic-wand.png';
                                    this.keyBenefitsTitle = 'Generate AI Response';
                                    this.field['innovation_key_benefits'] = 'undefined';
                                } else if (name === 'innovation_applications') {
                                    this.innovation.applications = response.data
                                    this.applicationsImg = '/images/magic-wand.png';
                                    this.applicationsTitle = 'Generate AI Response';
                                    this.field['innovation_applications'] = 'undefined';
                                }
                            }
                        })
                        .catch((error) => {
                            clearTimeout(timeoutId);
                            if (error.response && error.response.length > 0) {
                                this.$toasted.error(error.response.data);
                            }
                            this.field[name] = true
                            this.wand(name)
                        });
                }
            },
            typeWriter() {
                if (this.currentIndex < this.response.length) {
                    $('#short_description .ql-editor p').append(this.response[this.currentIndex]);
                    this.currentIndex++;
                    this.shortDescriptionTimeout = setTimeout(this.typeWriter, 50);
                } else if (this.currentIndex === this.response.length) {
                    this.shortDescriptionImg = '/images/magic-wand.png';
                    this.shortDescriptionTitle = 'Generate AI Response';
                    this.field['innovation_short_description'] = 'undefined';
                }
            },
            typeWriterLongDescription() {
                if (this.currentIndex < this.response.length) {
                    $('#long_description .ql-editor p').append(this.response[this.currentIndex]);
                    this.currentIndex++;
                    this.longDescriptionTimeout = setTimeout(this.typeWriterLongDescription, 50);
                } else if (this.currentIndex === this.response.length) {
                    this.longDescriptionImg = '/images/magic-wand.png';
                    this.longDescriptionTitle = 'Generate AI Response';
                    this.field['innovation_long_description'] = 'undefined';
                }
            },
            typeWriterStrapline() {
                if (this.straplineCurrentIndex < this.straplineResponse.length && this.innovation.strapline.length <= 80) {
                    this.innovation.strapline += this.straplineResponse[this.straplineCurrentIndex]
                    this.straplineCurrentIndex++;
                    this.straplineTimeout = setTimeout(this.typeWriterStrapline, 50);
                } else {
                    this.straplineImg = '/images/magic-wand.png';
                    this.straplineTitle = 'Generate AI Response';
                    this.field['innovation_strapline'] = 'undefined';
                }
            },
            typeWriterKeyBenefits() {
                if (this.keyBenefitsCurrentIndex < this.keyBenefitsResponse.length) {
                    $('#key_benefits .ql-editor p').append(this.keyBenefitsResponse[this.keyBenefitsCurrentIndex]);
                    this.keyBenefitsCurrentIndex++;
                    this.keyBenefitsTimeout = setTimeout(this.typeWriterKeyBenefits, 50);
                } else if (this.keyBenefitsCurrentIndex === this.keyBenefitsResponse.length) {
                    this.keyBenefitsImg = '/images/magic-wand.png';
                    this.keyBenefitsTitle = 'Generate AI Response';
                    this.field['innovation_key_benefits'] = 'undefined';
                }
            },
            typeWriterApplications() {
                if (this.applicationsCurrentIndex < this.applicationsResponse.length) {
                    $('#applications .ql-editor p').append(this.applicationsResponse[this.applicationsCurrentIndex]);
                    this.applicationsCurrentIndex++;
                    this.applicationsTimeout = setTimeout(this.typeWriterApplications, 50);
                } else if (this.applicationsCurrentIndex === this.applicationsResponse.length) {
                    this.applicationsImg = '/images/magic-wand.png';
                    this.applicationsTitle = 'Generate AI Response';
                    this.field['innovation_applications'] = 'undefined';
                }
            },
            webScrape() {
                this.ai_loading_ready = false;
                this.ai_loading = false;
                if (this.innovation.url) {
                    let regex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
                    let test = regex.test(this.innovation.url);
                    if (!test) {
                        this.$toasted.error('URL is not valid');
                        return
                    }
                    this.ai_loading_ready = false;
                    this.ai_loading = true;
                    axios.post('/api/v1/innovations/web-scrape', {
                        'url': this.innovation.url
                    })
                        .then((response) => {
                            this.ai_loading = false;
                            // this.ai_loading_ready = true;
                            this.scrapeDone = true
                            if (this.prev_url.length > 0 && this.prev_url !== this.innovation.url) {
                                this.wand('innovation_strapline')
                                this.wand('innovation_short_description')
                                this.wand('innovation_primary_sector')
                            }
                            this.prev_url = this.innovation.url
                        })
                        .catch((error) => {
                            this.$toasted.error(error.response.data);
                        });
                }
            },
            wand(prompt) {
                if (this.field[prompt] !== 'undefined') {
                    this.field[prompt] = this.field[prompt] !== true;
                } else {
                    this.field[prompt] = true;
                }
                if (this.field[prompt]) {
                    if (prompt === 'innovation_strapline') {
                        this.straplineImg = '/images/Rolling-1s-16px.gif';
                        this.straplineTitle = 'Loading';
                    } else if (prompt === 'innovation_short_description') {
                        this.shortDescriptionImg = '/images/Rolling-1s-16px.gif';
                        this.shortDescriptionTitle = 'Loading';
                    } else if (prompt === 'innovation_primary_sector') {
                        this.innovation.primary_sector_id = '';
                        this.primarySectorImg = '/images/Rolling-1s-16px.gif';
                        this.primarySectorTitle = 'Loading';
                    } else if (prompt === 'innovation_long_description') {
                        this.longDescriptionImg = '/images/Rolling-1s-16px.gif';
                        this.longDescriptionTitle = 'Loading';
                    } else if (prompt === 'innovation_key_benefits') {
                        this.keyBenefitsImg = '/images/Rolling-1s-16px.gif';
                        this.keyBenefitsTitle = 'Loading';
                    } else if (prompt === 'innovation_applications') {
                        this.applicationsImg = '/images/Rolling-1s-16px.gif';
                        this.applicationsTitle = 'Loading';
                    }
                    this.innovation.ai_integration = true;
                    this.getAi(prompt)
                } else {
                    // this.cancelRequest.cancel();
                    if (prompt === 'innovation_strapline') {
                        clearTimeout(this.straplineTimeout);
                        this.straplineImg = '/images/magic-wand.png';
                        this.straplineTitle = 'Generate AI Response';
                    } else if (prompt === 'innovation_short_description') {
                        clearTimeout(this.shortDescriptionTimeout);
                        this.shortDescriptionImg = '/images/magic-wand.png';
                        this.shortDescriptionTitle = 'Generate AI Response';
                    } else if (prompt === 'innovation_primary_sector') {
                        this.innovation.primary_sector_id = '';
                        this.primarySectorImg = '/images/magic-wand.png';
                        this.primarySectorTitle = 'Generate AI Response';
                    } else if (prompt === 'innovation_long_description') {
                        clearTimeout(this.longDescriptionTimeout);
                        this.longDescriptionImg = '/images/magic-wand.png';
                        this.longDescriptionTitle = 'Generate AI Response';
                    } else if (prompt === 'innovation_key_benefits') {
                        clearTimeout(this.keyBenefitsTimeout);
                        this.keyBenefitsImg = '/images/magic-wand.png';
                        this.keyBenefitsTitle = 'Generate AI Response';
                    } else if (prompt === 'innovation_applications') {
                        clearTimeout(this.applicationsTimeout);
                        this.applicationsImg = '/images/magic-wand.png';
                        this.applicationsTitle = 'Generate AI Response';
                    }
                }
            }
        },
        mounted () {
            let url = new URL(location.href);
            let step = url.searchParams.get("step");
            if (step) {
                this.step = step
            }

            if (this.step == 1) {
                this.step_1 = true
            } else if (this.step == 2) {
                this.step_1 = false;
                this.step_2 = true;
            } else if (this.step == 3) {
                this.step_1 = this.step_2 = false;
                this.step_3 = true;
            }

            SectorService.getSectors().then(data => {
                this.sectors = data;
            });
            BenefitService.getBenefits().then(data => {
                this.benefits = data;
            });
            CountryService.getCountries().then(data => {
                this.countries = data;
            });
            DevelopmentStageService.getDevelopmentStages().then(data => {
                this.developmentStages = data;
            });
            PatentStatusService.getPatentStatuses().then(data => {
                this.patentStatuses = data;
            });
            GeographicalAreaService.getGeographicalAreas().then(data => {
                this.geographicalAreas = data;
            });
            CompanyTypeService.getCompanyTypes().then(data => {
                this.companyTypes = data;
            });
            InvestmentTypeService.getInvestmentTypes().then(data => {
                this.investmentTypes = data;
            });
            CurrencyService.getCurrencies().then(data => {
                this.currencies = data;
            });

            this.stepsCalculation();

            if (innovationId && !sessionStorage.getItem('innovation') || (sessionStorage.getItem('innovation')
                && innovationId != JSON.parse(sessionStorage.getItem('innovation')).id)) {
                this.getInnovation(innovationId);
                this.justCreatedCheck();
                this.cardView = false;
            } else {
                this.postLoad();
            }

            sessionStorage.setItem("previous_url", location.href);
        },
        components: {
            'ToggleButton': ToggleButton,
            'SectorService': SectorService,
            'RadialProgressBar': RadialProgressBar
        },
        created() {
            let previous_url = sessionStorage.getItem('previous_url');
            if (previous_url && previous_url.includes("/innovation/edit") && location.href.includes("/innovation/create")) {
                sessionStorage.removeItem('innovation')
            }
            const innovation = sessionStorage.getItem('innovation');
            if (innovation) {
                this.innovation = JSON.parse(innovation);
            }
        },
        watch: {
            innovation: {
                handler(val){
                    this.stepsCalculation();
                    sessionStorage.setItem('innovation', JSON.stringify(val));
                },
                deep: true
            }
        }
    });
}